export function resolveDefaultProps<P extends object>(
  defaults: Partial<P> = {},
  props: P,
): P {
  const merged: P = { ...props };
  const defaultsRecord = defaults;
  for (const key in defaultsRecord) {
    if (merged[key] === undefined) {
      merged[key] = defaultsRecord[key]!;
    }
  }
  return merged as P;
}
